import { render } from "./DelayedValue.vue?vue&type=template&id=3ef246ec&scoped=true"
import script from "./DelayedValue.vue?vue&type=script&lang=js"
export * from "./DelayedValue.vue?vue&type=script&lang=js"

import "./DelayedValue.vue?vue&type=style&index=0&id=3ef246ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef246ec"]])

export default __exports__